import {Button, FullscreenPanel, FullscreenPanelBody, Grid, Switch, Typography} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import {useCallback} from 'react'

import {EventGoal, useFormUserEventHandler} from '../../lib/metrika'
import * as classes from './BusinessPlate.classes'
import {useBusinessPlate} from './BusinessPlate.hooks'
import {BusinessPlateModal} from './BusinessPlateModal/BusinessPlateModal'

export type BusinessPlateProps = {
  name: string
  metricaLabel?: EventGoal | string
}

export function BusinessPlate({name, metricaLabel}: BusinessPlateProps) {
  const {isModalOpen, toggleModal, field, fieldState, handleChange, handleActionButtonClick, showSwitch} =
    useBusinessPlate({name, metricaLabel})
  const i18n = useI18n()

  const handleReachGoal = useFormUserEventHandler()

  const handleSwitchChange = useCallback(
    (value: boolean) => {
      handleReachGoal(EventGoal.BusinessSwitchClick)
      handleChange(value)
    },
    [handleChange, handleReachGoal],
  )

  return (
    <>
      <Grid className={classes.plate} justify="space-between" container>
        <Grid>
          <Typography className={classes.title} group="tight" thickness="medium" variant="body2">
            {showSwitch
              ? i18n('order.form.business.plate.title.touched', 'Отправляю заказ клиенту')
              : i18n('order.form.business-plate.title', 'Бизнес-профиль')}
          </Typography>
          <Typography color="minor" group="tight" variant="caption1">
            {showSwitch
              ? i18n('order.form.business-plate.caption.touched', 'И хочу увидеть опции для бизнеса')
              : i18n('order.form.business-plate.caption', 'Новые возможности для вашей работы')}
          </Typography>
        </Grid>
        {showSwitch ? (
          <Switch
            className={classes.businessSwitch}
            data-e2e="business-switch"
            error={fieldState.invalid}
            on={field.value}
            onChange={handleSwitchChange}
            size="m"
          />
        ) : (
          <Button
            className={classes.button}
            onPress={toggleModal}
            shape="circle"
            size="xs"
            textVariant="caption2"
            variant="action"
          >
            {i18n('order.form.business-plate.button', 'Узнать')}
          </Button>
        )}
      </Grid>
      <FullscreenPanel color="invert" opened={isModalOpen}>
        <FullscreenPanelBody className={classes.panelBody}>
          <BusinessPlateModal onActionButtonClick={handleActionButtonClick} toggleModal={toggleModal} />
        </FullscreenPanelBody>
      </FullscreenPanel>
    </>
  )
}
